import { Autocomplete, Box, Chip, TextField } from "@mui/material"

function QueueContainer({ queues, selecteds, setSelecteds }) {
    const onChange = async (value) => {
        let optionsChanged = []

        optionsChanged = value

        setSelecteds(optionsChanged)
    }

    return (
        <Box sx={{ px: 1, width: "100%", maxWidth: 400 }}>
            <Autocomplete
                multiple
                size="small"
                options={queues}
                value={selecteds}
                freeSolo
                onChange={(e, value, reason) => onChange(value, reason)}
                getOptionLabel={(option) => (option.name ? option.name : "")}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                fullWidth
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            key={option.id || index}
                            variant="outlined"
                            style={{
                                backgroundColor: option.color || "#eee",
                                color: "white",
                                textShadow: "1px 1px 1px #000",
                            }}
                            label={option.name}
                            {...getTagProps({ index })}
                            size="small"
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Filas"
                    />
                )}
                // PaperComponent={({ children }) => (
                //     <Paper style={{ width: 400, marginLeft: 12 }}>
                //         {children}
                //     </Paper>
                // )}
            />
        </Box>
    )
}

export default QueueContainer
